export default "__VITE_ASSET__BN46o6jQ__"